
const Page = {
    records : 50
}

export default Page;
